var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"functionalBox"},[_c('h2',[_vm._v("功能特点")]),_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"characteristic"},[_c('img',{attrs:{"src":require(`@/assets/image/productCenter/`+item.icon),"alt":"功能特点"}}),_c('h3',[_vm._v(_vm._s(item.title))]),_c('p',[_vm._v(_vm._s(item.intro))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }